import React from 'react';
import { Check } from 'lucide-react';
import { whyChooseUs } from '../mockData';

const About = () => {
  return (
    <section id="about" className="py-12 md:py-16 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left Column - Text Content */}
          <div>
            {/* Section Header */}
            <div className="mb-8">
              <div className="flex items-center mb-4">
                <div className="w-16 h-0.5 bg-[#cab28e] mr-4" />
                <span className="text-[#cab28e] text-sm tracking-widest font-semibold">
                  {whyChooseUs.subtitle}
                </span>
              </div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-6">
                <span className="block">POUZDANOST</span>
                <span className="block text-[#cab28e]">IZVRSNOST</span>
              </h2>
            </div>

            {/* Description */}
            <p className="text-gray-400 text-lg leading-relaxed mb-8">
              {whyChooseUs.description}
            </p>

            {/* Mission */}
            <div className="bg-gray-900/50 border border-gray-800 rounded-lg md:rounded-xl p-6 lg:p-8 mb-8 md:hover:border-[#cab28e]/40 transition-colors duration-300">
              <h3 className="text-[#cab28e] font-bold text-lg mb-3 tracking-wide">
                {whyChooseUs.mission}
              </h3>
              <p className="text-gray-300 leading-relaxed">
                {whyChooseUs.missionText}
              </p>
            </div>

            {/* Values */}
            <div className="space-y-4">
              {whyChooseUs.values.map((value, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <div className="w-6 h-6 rounded-full bg-[#cab28e]/20 flex items-center justify-center flex-shrink-0">
                    <Check className="w-4 h-4 text-[#cab28e]" />
                  </div>
                  <span className="text-gray-300 text-lg">{value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Image Grid */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4 md:gap-5">
              <div className="space-y-4">
                <div className="aspect-square rounded-lg md:rounded-xl overflow-hidden">
                  <img
                    src="https://customer-assets.emergentagent.com/job_gradimo-future/artifacts/5xu0sdap_jpg_3688..png"
                    alt="Construction work"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="aspect-[4/3] rounded-lg md:rounded-xl overflow-hidden">
                  <img
                    src="https://customer-assets.emergentagent.com/job_gradimo-future/artifacts/q2mlo4qg_PNG_3444.png"
                    alt="Concrete work"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="aspect-[4/3] rounded-lg md:rounded-xl overflow-hidden">
                  <img
                    src="https://customer-assets.emergentagent.com/job_gradimo-future/artifacts/ub7hzend_IMG_4584.png"
                    alt="Foundation work"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="aspect-square rounded-lg md:rounded-xl overflow-hidden">
                  <img
                    src="https://customer-assets.emergentagent.com/job_gradimo-future/artifacts/sr7x2z21_IMG_4906.png"
                    alt="Finished building"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>
              </div>
            </div>

            {/* Decorative Element */}
            <div className="absolute -bottom-8 -left-8 w-32 h-32 border-4 border-[#cab28e]/30 rounded-lg -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
